export default [
  {
    path: '/active-gradereport-template/index',
    name: 'index',
    component: () => import('@/views/active-gradereport-template/index'),
    meta: {
      title: '分析报告'
    }
  },
  {
    path: '/active-gradereport-template/my-list',
    name: 'my-list',
    component: () => import('@/views/active-gradereport-template/my-list'),
    meta: {
      title: '分析报告'
    }
  },{
    path: '/active-gradereport-template/buy-record',
    name: 'buy-record',
    component: () => import('@/views/active-gradereport-template/buy-record'),
    meta: {
      title: '购买记录'
    }
  },{
    path: '/active-gradereport-template/about-our',
    name: 'about-our',
    component: () => import('@/views/active-gradereport-template/about-our'),
    meta: {
      title: '关于我们'
    }
  },{
    path: '/active-gradereport-template/msg-input',
    name: 'msg-input',
    component: () => import('@/views/active-gradereport-template/msg-input'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-template/first-msg',
    name: 'first-msg',
    component: () => import('@/views/active-gradereport-template/first-msg'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-template/grade-report',
    name: 'grade-report',
    component: () => import('@/views/active-gradereport-template/grade-report'),
    meta: {
      title: '高考录取预测报告'
    }
  },{
    path: '/active-gradereport-template/pay',
    name: 'pay',
    component: () => import('@/views/active-gradereport-template/pay'),
    meta: {
      title: '支付'
    }
  },{
    path: '/active-gradereport-template/payCity',
    name: 'payCity',
    component: () => import('@/views/active-gradereport-template/payCity'),
    meta: {
      title: '支付'
    }
  },{
    path: '/active-gradereport-template/payInfo',
    name: 'payInfo',
    component: () => import('@/views/active-gradereport-template/payInfo'),
    meta: {
      title: '支付详情'
    }
  },{
    path: '/active-gradereport-template/batch',
    name: 'batch',
    component: () => import('@/views/active-gradereport-template/batch'),
    meta: {
      title: '查批次'
    }
  },{
    path: '/active-gradereport-template/oneline',
    name: 'oneline',
    component: () => import('@/views/active-gradereport-template/oneline'),
    meta: {
      title: '一分一段'
    }
  },{
    path: '/active-gradereport-template/agreement',
    name: 'agreement',
    component: () => import('@/views/active-gradereport-template/agreement'),
    meta: {
      title: '协议内容'
    }
  },{
    path: '/active-gradereport-template/paySuccess',
    name: 'paySuccess',
    component: () => import('@/views/active-gradereport-template/paySuccess'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/active-gradereport-template/transit',
    name: 'transit',
    component: () => import('@/views/active-gradereport-template/transit'),
    meta: {
      title: ''
    }
  },
  {
    path: '/active-gradereport-template/transit-pay',
    name: 'transit-pay',
    component: () => import('@/views/active-gradereport-template/transit-pay'),
    meta: {
      title: ''
    }
  },
  {
    path: '/active-gradereport-template/home',
    name: 'home',
    component: () => import('@/views/active-gradereport-template/home'),
    meta: {
      title: '高考录取预测报告'
    }
  },
  {
    path: '/active-gradereport-template/record',
    name: 'record',
    component: () => import('@/views/active-gradereport-template/record'),
    meta: {
      title: '高考排名预估'
    }
  },
  {
    path: '/active-gradereport-template/introduction',
    name: 'introduction',
    component: () => import('@/views/active-gradereport-template/introduction'),
    meta: {
      title: '说明'
    }
  },
  {
    path: '/active-gradereport-template/cdkey',
    name: 'cdkey',
    component: () => import('@/views/active-gradereport-template/cdkey'),
    meta: {
      title: '模考预测报告兑换码'
    }
  },
]
